import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=65ec2e87&scoped=true&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&id=65ec2e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec2e87",
  null
  
)

export default component.exports